import React from "react";

import FaceMeshAsyncV2Page from "./FaceMeshAsyncV2Page";
import { buildFaceshapeUserPhotoContinueUrl } from "./faceshapeUserPhotoContinue";

const FACESHAPE_PROGRESS_STEPS = [
  { threshold: 10, label: "Analyzing face contour and silhouette" },
  { threshold: 35, label: "Checking facial symmetry and balance" },
  { threshold: 60, label: "Comparing jawline, forehead, and chin" },
  { threshold: 85, label: "Measuring key facial proportions" },
  { threshold: 100, label: "Determining your face shape" },
];

const FaceMeshFaceShapeV2Page = () => (
  <FaceMeshAsyncV2Page
    analyticsPrefix="facemesh_faceshape_v2"
    buildContinueUrlOverride={buildFaceshapeUserPhotoContinueUrl}
    continueUrl="/faceshape-3month-29"
    missingImageHelpPath="/facemesh-faceshape-v2"
    pagePath="/facemesh-faceshape-v2"
    progressSteps={FACESHAPE_PROGRESS_STEPS}
  />
);

export default FaceMeshFaceShapeV2Page;
